import { LoadScriptNext } from '@react-google-maps/api';
import React from 'react';

import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import WifiOffIcon from '@mui/icons-material/WifiOff';

import { CenteredCircularProgress } from 'components/Progress';

import { getDisplayName } from 'utils/hocs/name';
import { env } from 'config';
import { useOnlineMonitor } from 'utils/hooks/useOnlineMonitor';

const OfflineMessage: React.FC = () => (
  <Box display="flex" flexDirection="row" alignItems="center" gap={5}>
    <WifiOffIcon color="disabled" sx={{ fontSize: 32 }} />
    <Typography variant="subtitle1" color="text.secondary">
      Location search is unavailable offline
    </Typography>
  </Box>
);

const withGoogleMaps = <T extends {}>(WrappedComponent: React.ComponentType<T>): React.ComponentType<T> => {
  const WithGoogleMapsComponent: React.FC<T> = (props) => {
    const isOnline = useOnlineMonitor();

    if (!isOnline) {
      return <OfflineMessage />;
    }

    return (
      <LoadScriptNext
        id="google-maps-script-loader"
        googleMapsApiKey={env.REACT_APP_GOOGLE_MAPS_API_KEY as unknown as string}
        loadingElement={<CenteredCircularProgress />}
      >
        <WrappedComponent {...props} />
      </LoadScriptNext>
    );
  };

  WithGoogleMapsComponent.displayName = `withGoogleMaps(${getDisplayName(WrappedComponent)})`;

  return WithGoogleMapsComponent;
};

export default withGoogleMaps;
